<template>

  <div :class="{'has-logo':showLogo}" :style="{ backgroundColor: settings.sideTheme === 'theme-dark' ? '#304156' : '#ffffff' }" style="text-align: left">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar :class="settings.sideTheme" wrap-class="scrollbar-wrapper">
      <el-menu
          :default-active="activeMenu"
          :collapse="isCollapse"
          :background-color="settings.sideTheme === 'theme-dark' ? '#304156' : '#ffffff'"
          :text-color="settings.sideTheme === 'theme-dark' ? '#bfcbd9' : 'rgba(0,0,0,.70)'"
          :unique-opened="true"
          active-text-color="#409EFF"
          :collapse-transition="false"
          mode="vertical"
      >
        <sidebar-item
            v-for="(route, index) in sidebarRouters"
            :key="route.path  + index"
            :item="route"
            :base-path="route.path"
        />

      </el-menu>
    </el-scrollbar>
  </div>

</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "@/customerEnterpriseLayout/components/SidebarItem.vue";
import logo from "@/customerEnterpriseLayout/components/Logo.vue";
import Cookie from "js-cookie";

export default {
  components: {logo, SidebarItem},
  data() {
    return {
      showLogo: true,
      settings:{
        sideTheme: 'theme-dark',
      },
      sidebarRouters: [
        {
          path: '/customerEnterprise/home',
          hidden: false,
          meta: { title: '首页', activeMenu: '/customerEnterprise/home' , icon: 'el-icon-s-home'}
        },
        {
          path: '/customerEnterprise/record',
          hidden: false,
          meta: { title: '电子印章备案', activeMenu: '/customerEnterprise/record' , icon: 'el-icon-s-check'}
        },
        {
          path: '/customerEnterprise/list',
          hidden: false,
          meta: { title: '印章备案列表', activeMenu: '/customerEnterprise/list' , icon: 'el-icon-s-data'}
        },{
          path: '/customerEnterprise/orderList',
          hidden: false,
          meta: { title: '印章备案订单', activeMenu: '/customerEnterprise/orderList' , icon: 'el-icon-s-claim'}
        },{
          path: '/customerEnterprise/authorization',
          hidden: false,
          meta: { title: '客户端激活', activeMenu: '/customerEnterprise/authorization' , icon: 'el-icon-s-platform'}
        }
      ]
    };
  },
  created() {
    let orgCode = Cookie.get('orgCode')
    if (orgCode === '91210204341167191F'){
      let list = {
        path: '/customerEnterprise/invoiceOrderList',
        hidden: false,
        meta: { title: '发票订单', activeMenu: '/customerEnterprise/invoiceOrderList' , icon: 'el-icon-s-order'}
      }
      this.sidebarRouters.push(list)
    }
  },
  computed: {
    ...mapGetters(["sidebar"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    isCollapse() {
      return false;
    }
  }
}
</script>

<style scoped lang="less">
.sidebar-container {
  -webkit-transition: width .28s;
  transition: width 0.28s;
  width: 200px !important;
  background-color: #304156;
  height: 100%;
  position: fixed;
  font-size: 0px;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1001;
  overflow: hidden;
  -webkit-box-shadow: 2px 0 6px rgba(0,21,41,.35);
  box-shadow: 2px 0 6px rgba(0,21,41,.35);

  // reset element-ui css
  .horizontal-collapse-transition {
    transition: 0s width ease-in-out, 0s padding-left ease-in-out, 0s padding-right ease-in-out;
  }

  .scrollbar-wrapper {
    overflow-x: hidden !important;
  }

  .el-scrollbar__bar.is-vertical {
    right: 0px;
  }

  .el-scrollbar {
    height: 100%;
  }

  &.has-logo {
    .el-scrollbar {
      height: calc(100% - 33px);
    }
  }

  .is-horizontal {
    display: none;
  }

  a {
    display: inline-block;
    width: 100%;
    overflow: hidden;
  }

  a &:focus {
    outline: none;
  }

  .svg-icon {
    margin-right: 16px;
  }

  .el-menu {
    border: none;
    height: 100%;
    width: 100% !important;
  }

  .el-menu-item, .el-submenu__title {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  // menu hover
  .submenu-title-noDropdown,
  .el-submenu__title {
    &:hover {
      background-color: rgba(0, 0, 0, 0.06) !important;
    }
  }

  & .theme-dark .is-active > .el-submenu__title {
    color: #f4f4f5 !important;
  }

  & .nest-menu .el-submenu>.el-submenu__title,
  & .el-submenu .el-menu-item {
    min-width: 200px !important;

    &:hover {
      background-color: rgba(0, 0, 0, 0.06) !important;
    }

  }

  & .theme-dark .nest-menu .el-submenu>.el-submenu__title,
  & .theme-dark .el-submenu .el-menu-item {
    background-color: #1f2d3d !important;

    &:hover {
      background-color: #001528 !important;
    }
  }
}
</style>
